import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import ProductList from '../components/product/ProductList';
import { productService } from '../services/productService';
import SEO from '../components/common/SEO';
import './Products.css';

const Products = () => {
  const [searchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pageTitle, setPageTitle] = useState('All Products');

  const category = searchParams.get('category');
  const search = searchParams.get('search');
  const sortBy = searchParams.get('sortBy');
  const sortOrder = searchParams.get('sortOrder');

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        setError(null);

        // Build query parameters
        const params = {};
        if (category) params.category = category;
        if (search) params.search = search;
        if (sortBy) params.sortBy = sortBy;
        if (sortOrder) params.sortOrder = sortOrder;

        // Fetch products from API
        const data = await productService.getAllProducts(params);

        // Handle different response structures
        let productsList = [];
        if (Array.isArray(data)) {
          productsList = data;
        } else if (data?.products) {
          productsList = data.products;
        } else if (data?.data?.products) {
          productsList = data.data.products;
        }

        setProducts(productsList);

        // Update page title based on category
        if (category) {
          // Capitalize first letter and replace hyphens with spaces
          const categoryName = category
            .split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
          setPageTitle(`${categoryName} Products`);
        } else if (search) {
          setPageTitle(`Search Results for "${search}"`);
        } else {
          setPageTitle('All Products');
        }
      } catch (err) {
        setError(err.message || 'Failed to load products');
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [category, search, sortBy, sortOrder]);

  return (
    <div className="products-page">
      <SEO
        title={pageTitle}
        description={`Browse our collection of ${pageTitle.toLowerCase()} at Essentick. Quality watches and lifestyle products in Nepal.`}
        keywords={`watches, Nepal, ${pageTitle.toLowerCase()}, premium watches, Essentick`}
      />
      <div className="products-header">
        <h1>{pageTitle}</h1>
      </div>

      <div className="products-content full-width">
        <main className="products-main">
          <ProductList products={products} loading={loading} error={error} />
        </main>
      </div>
    </div>
  );
};

export default Products;
